import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  id: "Print-Text--Streamline-Streamline--3.0",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Print Text Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M5.75 6a1 1 0 0 0 1 -1V2h8.84l2.16 2.16V5a1 1 0 0 0 2 0V3.75a1 1 0 0 0 -0.29 -0.75L17 0.59A2 2 0 0 0 15.59 0H6.75a2 2 0 0 0 -2 2v3a1 1 0 0 0 1 1Z",
        fill: "currentColor",
        "stroke-width": "1"
      }),
      _createElementVNode("path", {
        d: "M21.5 7h-19A2.5 2.5 0 0 0 0 9.5V14a2.5 2.5 0 0 0 2.5 2.5H5v6.25A1.25 1.25 0 0 0 6.25 24h12a1.25 1.25 0 0 0 1.25 -1.25V16.5h2A2.5 2.5 0 0 0 24 14V9.5A2.5 2.5 0 0 0 21.5 7Zm-18 4.5a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm14 10a0.5 0.5 0 0 1 -0.5 0.5H7.5a0.5 0.5 0 0 1 -0.5 -0.5v-9a0.5 0.5 0 0 1 0.5 -0.5H17a0.5 0.5 0 0 1 0.5 0.5Z",
        fill: "currentColor",
        "stroke-width": "1"
      }),
      _createElementVNode("path", {
        d: "M15 14.75H9.5a0.75 0.75 0 0 0 0 1.5H15a0.75 0.75 0 0 0 0 -1.5Z",
        fill: "currentColor",
        "stroke-width": "1"
      }),
      _createElementVNode("path", {
        d: "M13.25 18.25H9.5a0.75 0.75 0 0 0 0 1.5h3.75a0.75 0.75 0 0 0 0 -1.5Z",
        fill: "currentColor",
        "stroke-width": "1"
      })
    ], -1)
  ])))
}
export default { render: render }